import { Fragment, useCallback, useRef } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Webcam from "react-webcam";


const videoConstraints = {
  width: 620,
  height: 340,
  facingMode: "environment"  
};

export default function CameraDialog(props:any) {  
  //const [isCaptureEnable, setCaptureEnable] = useState<boolean>(true);
  const webcamRef = useRef<Webcam>(null);
  
  
  const TakePhoto = useCallback(() => {
    const imageSrc = webcamRef.current?.getScreenshot();
    if (imageSrc) {
        props.setUrl(imageSrc);      
    }
  }, [webcamRef]);
  const handleClose = () => {
    props.setUrl(null);
    props.setTakePicture(false);
  };
  const SavePhoto =()=> {
    props.setTakePicture(false);
  }


  return (
    <Fragment>    
      <Dialog
        style={ {width: '100%' ,height: '100%'}}        
        open={props.openCam}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();            
            handleClose();
          },
        }}
      >
        <DialogTitle>Take a Photo</DialogTitle>
        <DialogContent>
          <DialogContentText>           
          <Webcam
              audio={false}
              width={540}
              height={360}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              screenshotQuality={0.5}        
              videoConstraints={videoConstraints}
            /> 
            {props.url && (
                <>
                <div>
                 Taken Photo
                    <img src={props.url} alt="Screenshot" />
                </div>
                </>
            )}   
          </DialogContentText>          
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={TakePhoto}>Take Photo</Button>
          <Button onClick={SavePhoto}>Save Photo</Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}